import { UserDoctorSolidIcon, VideoSolidIcon } from "@elixir/icons";
import { MODES_OF_APT, SUBJECT_KEYS } from "@elixir/types";
import { getAclViewClassName } from "@elixir/utils";
import { SelectModeComponentUi } from "ui";
import useQueueStore from "../../../../stores/queue-store";
import { Select } from "antd";
import { useQueryClient } from "@tanstack/react-query";
import {
  getSlotsPref,
  setSlotsPref,
  SlotsPref,
} from "../../../../utils/get-calendar-slot-mode";
import { useState } from "react";

const items = [
  {
    label: "In-Clinic",
    value: MODES_OF_APT.IN_CLINIC,
    icon: <UserDoctorSolidIcon className="dr-w-16 dr-h-16" />,
  },
  {
    label: "Tele-Consultation",
    value: MODES_OF_APT.TELE,
    icon: <VideoSolidIcon className="dr-w-16 dr-h-16" />,
  },
];

const SLOTS_OPTIONS = [
  { label: "Flexible Time Slots", value: "free" as SlotsPref },
  { label: "Fixed (Scheduled based)", value: "fixed" as SlotsPref },
];

const SelectMode = () => {
  const setMode = useQueueStore((state) => state.setMode);
  const mode = useQueueStore((state) => state.mode);
  const queryClient = useQueryClient();
  const [slotsPref, setSlotsPrefState] = useState<SlotsPref | null>(
    getSlotsPref
  );

  const handleSlotsChange = (value: SlotsPref) => {
    setSlotsPref(value);
    setSlotsPrefState(value);
    queryClient.invalidateQueries(["slots"]);
  };

  return (
    <>
      <div className="dr-relative">
        <SelectModeComponentUi mode={mode} setMode={setMode} items={items} />
        <div
          className={`dr-absolute dr-top-7 dr-right-16 dr-flex dr-items-center dr-gap-x-8 ${getAclViewClassName(
            SUBJECT_KEYS.SHOW_SLOTS_OF_SEO_PAGE
          )}`}
        >
          <span className="Caption1Medium BodyBody2Bold dr-whitespace-nowrap dr-tracking-wide">
            Slot Type
          </span>
          <Select
            value={slotsPref ?? "free"}
            onChange={handleSlotsChange}
            options={SLOTS_OPTIONS}
            dropdownMatchSelectWidth={false}
            className="ant-selector-transparent dr-h-36 dr-flex dr-items-center BodyBody2Regular dr-rounded-8 dr-cursor-pointer"
            style={{ minWidth: 148 }}
          />
        </div>
      </div>
      <div className="dr-w-full dr-h-1 dr-bg-darwin-neutral-100" />
    </>
  );
};

export default SelectMode;
